import React from 'react';

import { LegacyBox } from '@gogame/components';
import { withForm, DialogV2 } from '@gogame/form';

import { AmountField, AffectedDimensions } from './components';
import { getNewAmount, Note } from './components';
import { LIFETIME_BUDGET } from './constants';

const LifetimeBudgetForm = withForm({
  enableReinitialize: true,

  mapPropsToValues: ({ mapEntityToValues, entities }) => {
    if (entities.length === 1) {
      return mapEntityToValues(entities[0]);
    }
    return {};
  },
  handleSubmit: ({ budgetAction }, { props }) => {
    props.resolve(
      props.entities.map((entity) => {
        const { [LIFETIME_BUDGET]: initialBudget, ...other } =
          props.mapEntityToValues(entity);
        const newAmount = getNewAmount(initialBudget, budgetAction);
        return {
          ...other,
          [LIFETIME_BUDGET]:
            newAmount !== null ? +(newAmount * 100).toFixed(2) : newAmount,
        };
      })
    );
  },
})(({ loading, values, dimensionName, entities, onClose, onExited, open }) => {
  return (
    <DialogV2
      onClose={onClose}
      open={open}
      onExited={onExited}
      fullWidth={true}
      size={'md'}
      loading={loading}
    >
      <DialogV2.Title title={`Edit ${dimensionName} Lifetime Budget`} />
      <DialogV2.Content padding={0}>
        <LegacyBox vertical={true}>
          <AffectedDimensions
            dimensionName={dimensionName}
            entities={entities}
          />
          <AmountField
            name={'budgetAction'}
            unit={'Budget'}
            initial={values[LIFETIME_BUDGET]}
            withPreview={entities.length <= 1}
          />
          <Note
            dimensionName={dimensionName}
            unit={'budget'}
            bulk={entities.length > 1}
          />
        </LegacyBox>
      </DialogV2.Content>
      <DialogV2.Actions>
        <DialogV2.CloseButton />
        <DialogV2.SubmitButton />
      </DialogV2.Actions>
    </DialogV2>
  );
});

export default LifetimeBudgetForm;
